import { render } from "./LearnIndex.vue?vue&type=template&id=f9955fb4&scoped=true"
import script from "./LearnIndex.vue?vue&type=script&lang=js"
export * from "./LearnIndex.vue?vue&type=script&lang=js"

import "./LearnIndex.vue?vue&type=style&index=0&id=f9955fb4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9955fb4"]])

export default __exports__